import { SearchIndexFilename } from "./SearchConstantForScript";

export { SearchIndexFilename } from "./SearchConstantForScript";
export { DOC_PATH, HOME_PATH, SEARCH_PATH } from "./GlobalConstant";

export const SearchTagName = "search_value";
export const SearchOccurenceOffsetIndexTagName = "search_occurence_offset_index";
export const SearchFilterApiPrefix = "search_filter_api_";
export const SearchFilterSdkPrefix = "search_filter_sdk_";
export const SearchFilterOtherPrefix = "search_filter_other_";
export const SearchTabIndex = "search_tab_index";

export const HUB = "Hub";
export const WEB = "Web";
export const NODE = "Node";
export const ANDROID = "Android";
export const IOS = "iOS";
export const CSHARP = "CSharp";
export const REACTNATIVE = "ReactNative";
export const REST = "Rest";
export const CLI = "Cli";
export const S2S = "S2s";

export const Sdk = {
    CSHARP: CSHARP,
    WEB: WEB,
    IOS: IOS,
    ANDROID: ANDROID,
    REACTNATIVE: REACTNATIVE,
    NODE: NODE
}

export const Api = {
    CLI: CLI,
    REST: REST,
    S2S: S2S,
}

export const Other = {
    HUB: HUB
}

export const SearchFilterText = "textFilter";
export const SearchMinLength = 3;
export const SEARCH_START_TIME = 300;

export const SearchIndexPaths = {
    HubIndex : "/hub/" + SearchIndexFilename,
    WebIndexLts: "/sdk/web/lts/" + SearchIndexFilename,
    WebIndexSts: "/sdk/web/sts/" + SearchIndexFilename,
    NodeIndexLts: "/sdk/node/lts/" + SearchIndexFilename,
    NodeIndexSts: "/sdk/node/sts/" + SearchIndexFilename,
    AndroidIndexLts: "/sdk/android/lts/" + SearchIndexFilename,
    AndroidIndexSts: "/sdk/android/sts/" + SearchIndexFilename,
    IosIndexLts: "/sdk/ios/lts/" + SearchIndexFilename,
    IosIndexSts: "/sdk/ios/sts/" + SearchIndexFilename,
    CSharpIndexCommonLts: "/sdk/csharp/common/lts/" + SearchIndexFilename,
    CSharpIndexCommonSts: "/sdk/csharp/common/sts/" + SearchIndexFilename,
    CSharpIndexCoreLts: "/sdk/csharp/core/lts/" + SearchIndexFilename,
    CSharpIndexCoreSts: "/sdk/csharp/core/sts/" + SearchIndexFilename,
    CSharpIndexWpfLts: "/sdk/csharp/wpf/lts/" + SearchIndexFilename,
    CSharpIndexWpfSts: "/sdk/csharp/wpf/sts/" + SearchIndexFilename,
    CSharpIndexWebRtcLts: "/sdk/csharp/webrtc/lts/" + SearchIndexFilename,
    CSharpIndexWebRtcSts: "/sdk/csharp/webrtc/sts/" + SearchIndexFilename,
    ReactNativeIndex: "/sdk/reactnative/" + SearchIndexFilename,
    RestIndex: "/rest/" + SearchIndexFilename,
    CliIndex: "/sdk/cli/" + SearchIndexFilename,
    S2sIndex: "/sdk/s2s-starterkit-nodejs/" + SearchIndexFilename
};
